'use strict';

angular.module('webAgro1App').factory('TratamentoSementeService', function ($http) {
  return {
    list(params = {}) {
      return $http.get(`${SERVER}v1/tratamento_sementes`, { params });
    },

    listTipos() {
      return $http.get(SERVER + API_VERSION + 'tipos_tratamento_semente');
    }
  };
});
